import { render, staticRenderFns } from "./FareOptionsColumn.vue?vue&type=template&id=605bae1a&"
import script from "./FareOptionsColumn.vue?vue&type=script&lang=js&"
export * from "./FareOptionsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports